import { useCallback } from 'react';

import type { ProjectListing } from '@/api/v4/projects.api';
import { formatNotApplicable } from '@/helpers/format-empty';
import { openNewTab } from '@/helpers/open-new-tab';
import { colors } from '@/theme/colors';
import { IconButton } from '@/ui/button/icon-button';
import { Stack } from '@/ui/line/line';
import { Logo } from '@/ui/logo/logo';
import { Tooltip } from '@/ui/tooltip/tooltip';

import {
  CompanyName,
  CompanyNameContainer,
  CompanyNameRow,
  KeyOffering,
  RowCheckbox,
} from '../styles/enhance-modal.styles';

export const CompanyNameTableCell = ({
  isChecked,
  listing,
  onToggle,
}: {
  isChecked: boolean;
  listing: ProjectListing;
  onToggle: () => void;
}) => {
  const handleToggleCompany = useCallback(() => {
    onToggle();
  }, [onToggle]);

  const handleWebsiteButtonClicked = (url: string | null) => {
    if (url) openNewTab(url);
  };

  return (
    <CompanyNameContainer name="company-name-container" gap="8px" height="65px">
      <Stack gap="0px" minWidth="0">
        <CompanyNameRow
          id={`enhance-company-option-${listing.organization.id}`}
          name={`enhance-company-option-${listing.organization.id}`}
          alignItems="center"
        >
          <RowCheckbox
            checked={isChecked}
            id={listing.organization.id}
            label=""
            onChange={handleToggleCompany}
          />
          <Logo
            singleLetter
            name={listing.organization.name}
            logoUrl={listing.organization.logoUrl ?? undefined}
            bgColor={colors.accent.green.c3}
            border={
              listing.organization.logoUrl
                ? `2px solid ${colors.gray.c3}`
                : undefined
            }
          />
          <CompanyName>{listing.organization.name}</CompanyName>
          {!!listing.organization.website && (
            <Tooltip
              content={listing.organization.website}
              placement="top"
              maxWidth="fit-content"
            >
              <IconButton
                icon="Globe"
                variant="ghost"
                color={colors.basics.black}
                onClick={() =>
                  handleWebsiteButtonClicked(listing.organization.website)
                }
              />
            </Tooltip>
          )}
        </CompanyNameRow>
        <KeyOffering
          id={`enhance-company-option-${listing.organization.id}-keyoffering`}
          name={`enhance-company-option-${listing.organization.id}-keyoffering`}
          alignItems="center"
        >
          {formatNotApplicable(listing.organization.keyOffering)}
        </KeyOffering>
      </Stack>
    </CompanyNameContainer>
  );
};
